import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import {
  setLoading,
  setList,
  setError,
  clearList,
} from "../../store/slices/inventory/productStockLookupSlice";

import ProductStockLookupService from "../../services/inventory/ProductStockLookupService";

export const useProductStockLookup = () => {
  const dispatch: AppDispatch = useDispatch();

  const { list, paginator, isLoading, error } = useSelector(
    (state: RootState) => state.productStockLookup
  );

  /**
   * Listar/buscar productos por sucursal (+ término opcional), paginado.
   */
  const search = async (branchId: number, term = "", page = 0, size = 10) => {
    if (!branchId) {
      dispatch(clearList());
      return;
    }

    try {
      dispatch(setLoading(true));
      const data = await ProductStockLookupService.search(branchId, term, page, size);
      dispatch(setList({ content: data.content, paginator: data }));
    } catch (err: any) {
      dispatch(setError("Error al buscar productos en stock."));
    } finally {
      dispatch(setLoading(false));
    }
  };

  /** limpiar resultados */
  const reset = () => dispatch(clearList());

  return {
    list,
    paginator,
    isLoading,
    error,

    search,
    reset,
  };
};
